import React, { Component } from 'react';
import { connect } from "react-redux";
import moment from "moment";
import { Trans } from 'react-i18next';

import { constants } from '../../../Helpers/Constants';
import VehicleCell from "../../Pages/Stakeholder/Vehicle/VehicleCell";
import ProfileCell from "../../Pages/Stakeholder/User/ProfileCell";

import Badge from '../Badge';
import LabelledOutline from '../LabelledOutline';

import { CancelBookingButton } from './CancelBookingButton';
import { RejectApproveBookingButtons } from './RejectApproveBookingButtons';
import Button from '../DesignSystem/Button';
import { getTimeZoneAbbreviation } from '../../../Helpers/getTimeZoneAbbreviation';
import colours from '../DesignSystem/Colours';

//A React component will allow us to quickly iterate and change our code. It provides 
class ViewBookingPullout extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.highlightEvent)
            this.props.highlightEvent(this.props.booking?.event, true);
    }

    componentDidUpdate(prevProps) {
        if (prevProps && prevProps.booking !== this.props.booking && prevProps.highlightEvent) {
            prevProps.highlightEvent(prevProps.booking?.event, false);
            if (this.props.highlightEvent)
                this.props.highlightEvent(this.props.booking?.event, true);
        }
    }

    componentWillUnmount() {
        if (this.props.highlightEvent)
            this.props.highlightEvent(this.props.booking?.event, false);
    }

    renderUser(profile) {
        if (this.props.booking.Book_Type == constants.booking_type.service) {
            profile.Book_Type = constants.booking_type.service;
        }
        return (
            <LabelledOutline label="User" id="user">
                <div style={{ display: 'flex', flex: 1 }}>
                    <ProfileCell
                        profile={profile}
                        showImage
                        showContact={this.props.booking.Book_Type != constants.booking_type.service}
                        match={this.props.match}
                        history={this.props.history} />
                </div>
            </LabelledOutline>
        )
    }

    render() {
        const scheduledReleasedAt = this.props.stakeholder.current_booking?.extendedProps?.booking?.scheduledReleasedAt
            ? moment(this.props.stakeholder.current_booking.extendedProps.booking.scheduledReleasedAt).format('YYYY-MM-DDTHH:mm:ssZ')
            : this.props.stakeholder.current_booking.Start_Date;

        const scheduledReturnedAt = this.props.stakeholder.current_booking?.extendedProps?.booking?.scheduledReturnedAt
            ? moment(this.props.stakeholder.current_booking.extendedProps.booking.scheduledReturnedAt).format('YYYY-MM-DDTHH:mm:ssZ')
            : this.props.stakeholder.current_booking.End_Date;

        if (this.props.booking) {
            return (
                <div className="booking_pullout new_booking_pullout">
                    <div className="booking_header border-bottom">
                        <div className="card-header-title no-margin float-left" style={{ display: 'flex', flexDirection: 'row' }}>
                            <Trans>Booking Details</Trans>
                            <div style={{ marginLeft: 10, verticalAlign: 'top', paddingTop: 0, paddingBottom: 0 }}>
                                <Badge status={this.props.booking.Book_Status} service={this.props.booking.Book_Type == 2} completed={this.props.booking.Returned_On !== null} />
                            </div>
                        </div>
                        <button onClick={this.props.closePullout} type='button' style={{ cursor: "pointer", position: 'fixed', right: 10, top: 20 }} className="float-right">
                            <span aria-hidden='true' style={{ fontSize: "1.8em", lineHeight: 1, display: "block" }}>&times;</span>
                        </button>
                        <div className="clearfix"></div>
                    </div>
                    <div className="card-section">
                        <div className="row mb-24">
                            <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={this.props.booking.vehicle} noOverlay showType noTooltip />
                            <div className="new_booking_pullout_vehicle-image-container">
                                {this.props.booking?.extendedProps?.vehicle?.photoUrl ? (
                                    <img
                                        style={{ borderRadius: '15px' }}
                                        src={this.props.booking.extendedProps.vehicle.photoUrl}
                                    />
                                ) : (
                                    <img
                                        style={{ borderRadius: '15px' }}
                                        src={this.props.booking.vehicle && this.props.booking.vehicle.Photos ?
                                            'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + this.props.booking.vehicle.Photos
                                            : this.props.settings.images.vehicle_placeholder_square.includes("images/") ?
                                                this.props.settings.images.vehicle_placeholder_square
                                                : "images/" + this.props.settings.images.vehicle_placeholder_square}
                                    />
                                )}
                            </div>
                        </div>
                        {this.props.booking.profile ?
                            <div className="mb-12">
                                {this.renderUser(this.props.booking.profile)}
                            </div> : null}
                        <div className="row mb-24">
                            {
                                this.props.booking.Book_Type === constants.booking_type.service ?
                                    <LabelledOutline label="Service Type" id="usage">
                                        <div style={{ display: 'flex', flex: 1 }}>
                                            {this.props.booking.Vehicle_Usage}
                                        </div>
                                    </LabelledOutline>
                                    :
                                    <LabelledOutline label="Vehicle Usage" id="usage">
                                        <div style={{ display: 'flex', flex: 1 }}>
                                            {this.props.settings.vehicle_usage_types[this.props.booking.Usage_Type]}
                                        </div>
                                    </LabelledOutline>
                            }
                        </div>
                        <div className="row mb-24">
                            <LabelledOutline label="Dates & Times" id="datesandtimes">
                                <div className="datesandtimes">
                                    <div className="pickup view">
                                        <div className="dayofweek">
                                            {moment(scheduledReleasedAt).format("dddd")}
                                        </div>
                                        <div className="date">
                                            {moment(scheduledReleasedAt).format("MMM DD, YYYY")}
                                        </div>
                                        <div className="date">
                                            {this.props.stakeholder.current_booking?.extendedProps?.booking?.scheduledReleasedAt ?
                                                moment(scheduledReleasedAt).format("h:mmA")
                                                : this.props.stakeholder.current_booking?.Release_Time ?
                                                    moment(this.props.stakeholder.current_booking.Release_Time, "HH:mm:ss").format("h:mmA")
                                                    : null
                                            }
                                        </div>
                                        <div className="button-with-caption">
                                            {this.props.booking.Released_On !== null ?
                                                <div>
                                                    <a className="button primary action_disabled"><Trans>Released</Trans></a>
                                                    <div className="button-caption" >
                                                        <p>{moment(this.props.booking.Released_On).format('h:mmA, MMM DD, YYYY')}</p>
                                                    </div>
                                                </div> :
                                                this.props.stakeholder.current_booking.Book_Status > 2 ?
                                                    <div>
                                                        <a className="button primary action_disabled"><Trans>Release</Trans></a>
                                                        <div className="button-caption hidden">
                                                            <p>N/A</p>
                                                        </div>
                                                    </div> :
                                                    <div>
                                                        <a className="button primary" onClick={() => { this.props.history.push(`${this.props.match.url}/release/${this.props.booking.BOOK_ID}`) }}><Trans>Release</Trans></a>
                                                        <div className="button-caption hidden">
                                                            <p>N/A</p>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="arrow">
                                        <i className="fas fa-arrow-right overlay_section_details_date_arrow" style={{ fontSize: '32px', color: 'lightgrey', marginTop: 45 }}></i>
                                    </div>
                                    <div className="dropoff view">
                                        <div className="dayofweek">
                                            {moment(scheduledReturnedAt).format("dddd")}
                                        </div>
                                        <div className="date">
                                            {moment(scheduledReturnedAt).format("MMM DD, YYYY")}
                                        </div>
                                        <div className="date">
                                            {this.props.stakeholder.current_booking?.extendedProps?.booking?.scheduledReturnedAt ?
                                                moment(scheduledReturnedAt).format("h:mmA")
                                                : this.props.stakeholder.current_booking?.Return_Time ?
                                                    moment(this.props.stakeholder.current_booking.Return_Time, "HH:mm:ss").format("h:mmA")
                                                    : null
                                            }
                                        </div>
                                        <div className="button-with-caption">
                                            {this.props.booking.Released_On !== null ?
                                                this.props.booking.Returned_On !== null ?
                                                    <div>
                                                        <a className="button primary action_disabled"><Trans>Checked In</Trans></a>
                                                        <div className="button-caption">
                                                            <p>{moment(this.props.booking.Returned_On).format('h:mmA, MMM DD, YYYY')}</p>
                                                        </div>
                                                    </div> :
                                                    <div>
                                                        <a className="button primary" onClick={() => { this.props.history.push(`${this.props.match.url}/return/${this.props.booking.BOOK_ID}`) }}><Trans>Check In</Trans></a>
                                                        <div className="button-caption hidden">
                                                            <p>N/A</p>
                                                        </div>
                                                    </div> :
                                                <div>
                                                    <a className="button primary action_disabled"><Trans>Check In</Trans></a>
                                                    <div className="button-caption hidden">
                                                        <p>N/A</p>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </LabelledOutline>
                        </div>
                        <div className="mb-24">
                            <Button
                                secondary
                                leading_ic="Clock"
                                label={`Timezone: ${getTimeZoneAbbreviation(this.props.booking.vmh.Display_City)} – ${this.props.booking.vmh.Display_City}`}
                                style={{ color: colours.primary.grey01 }}
                            />
                        </div>
                        <div className="row collapse">
                            <LabelledOutline label="Booking Notes" id="notes">
                                <div style={{ minHeight: '50px' }}>
                                    {this.props.booking.Special_Requests}
                                </div>
                            </LabelledOutline>
                        </div>
                    </div>
                    {this.props.booking.Book_Status >= 3 || this.props.booking.status === 'pending' ?
                        <div className="booking_bottom border-top" style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                            <RejectApproveBookingButtons
                                booking={this.props.booking}
                                legacyAPIApproveBooking={this.props.approveBooking}
                                openRejectBookingModal={this.props.rejectBooking}
                            />
                            <div style={{ justifyContent: 'flex-end', marginLeft: 'auto' }}>
                                <a className="button primary ml-16" onClick={this.props.toggleEditBooking}><Trans>Edit</Trans></a>
                            </div>
                        </div>
                        : <div className="booking_bottom border-top">
                            <CancelBookingButton
                                calendarBooking={this.props.booking}
                                legacyAPICancelBooking={this.props.cancelBooking}
                                dispatch={this.props.dispatch}
                            />
                            <a className="button primary ml-16" onClick={this.props.toggleEditBooking}><Trans>Edit</Trans></a>
                        </div>
                    }
                </div>
            )
        } else {
            return null;
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings,
    stakeholder: store.stakeholder
});

export default connect(mapStateToProps)(ViewBookingPullout);